<template>
	<div>
		<el-container class="navpage" >
			<el-main style="padding: 0 10px;">
				<div style="height: 100%;" @click="rightClickVisible = false">
				<div class="text-left" style="margin-bottom: 15px;" >
					<el-button type="warning" size="mini" @click="toUpDir" :disabled="path ? false : true">
						返回上级目录
						<span v-if="path">({{ path + '/' }})</span>
					</el-button>
					<el-button type="warning" size="mini" @click="crtNewDir">新建文件夹</el-button>
					<el-button type="success" size="mini" @click="moveFileToDir('root')">移动文件至根目录</el-button>
					<el-button type="primary" size="mini" @click="dialogVisible = true">上传文件</el-button>
					<el-button type="danger" size="mini" @click="deleteFile">删除</el-button>
					<el-button type="danger" size="mini" @click="scanFile">扫描文件</el-button>
					<!-- <el-button :type="viewType == 1 ? 'success' : 'info'" size="mini" @click="viewType = 1">预览模式</el-button> -->
					<!-- <el-button :type="viewType == 2 ? 'success' : 'info'" size="mini" @click="viewType = 2">列表模式</el-button> -->
				</div>
				<div v-if="viewType == 1" class="view_preview">
					<div class="view-item" v-for="(file, index) in fileList" :key="index">
						<template v-if="file.filedir_isdir">
							<div @click="fileRowClick(file)" @contextmenu.prevent="openMenu($event, file)">
								<i class="iconfont icon-wenjianjia file_type" :title="file.filedir_name"></i>
								<p :title="file.filedir_name">{{ file.filedir_name }}</p>
							</div>
						</template>
						<template v-else>
							<div @click="fileRowClick(file)">
								<img v-if="file.file_type == 'image'" :title="file.file_title" :src="HOST + file.file_src" />
								<i v-else class="iconfont file_type" :class="'icon-'+file.file_ext" :title="file.file_title"></i>
								<p>{{ file.file_title }}</p>
								<i class="iconfont icon-xuanzhong" v-show="fileIsChecked(file)"></i>
							</div>
						</template>
					</div>
				</div>
				<el-table
					v-else-if="viewType == 2"
					:data="fileList"
					style="width: 100%;margin-bottom: 20px;"
					row-key=""
					:stripe="true"
					tooltip-effect="dark"
					ref="multipleTable"
					@row-click="fileRowClick"
					:row-style="{ cursor: 'pointer' }"
					@selection-change="selectChange"
				>
					<el-table-column type="selection" width="55" :selectable="canCheck"></el-table-column>
					<el-table-column prop="file_filename" label="模板文件名">
						<template slot-scope="scope">
							<i v-if="scope.row.filedir_isdir" class="iconfont icon-wenjianjia"></i>
							<i v-else class="iconfont file_type" :class="'icon-' + scope.row.file_ext" :title="scope.row.file_title"></i>
							{{ scope.row.filedir_name?scope.row.filedir_name:scope.row.file_filename }}
						</template>
					</el-table-column>
					<el-table-column prop="file_ext" label="文件类型"></el-table-column>
					<el-table-column prop="createtime" label="创建时间"></el-table-column>
					<el-table-column prop="changetime" label="修改时间"></el-table-column>
				</el-table>
				</div>
			</el-main>
		</el-container>
		<el-dialog title="新建文件夹" :visible.sync="crtDirShow" width="80%" style="text-align: left;" :close-on-click-modal="false">
			<el-row :gutter="20">
				<el-col :span="4">文件夹名称</el-col>
				<el-col :span="16"><el-input type="text" v-model="ctrDir.filedir_name" placeholder="请输入文件夹名称"></el-input></el-col>
			</el-row>
			<div slot="footer" class="dialog-footer text-center">
				<el-button type="success" @click="crtDirConfirm">确 定</el-button>
				<el-button type="warning" @click="crtDirShow = false">关闭窗口</el-button>
			</div>
		</el-dialog>
		<el-dialog title="上传文件" :visible.sync="dialogVisible" width="80%" style="text-align: left;" :close-on-click-modal="false">
			<el-upload
				ref="fileupload"
				class="upload-demo"
				drag
				:action="HOST + '/admin.files/uploadMultiFile'"
				:data="{ adminid: JSON.parse($store.state.user.userInfo).id, token: JSON.parse($store.state.user.userInfo).token, path: path }"
				:auto-upload="false"
				:accept="uploadAccept"
				:multiple="true"
				:http-request="uploadFile"
			>
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">
					将文件拖到此处，或
					<em>点击上传</em>
				</div>
			</el-upload>
			<div slot="footer" class="dialog-footer text-center">
				<el-button type="success" @click="subPicForm">确 定</el-button>
				<el-button type="warning" @click="dialogVisible = false">关闭窗口</el-button>
			</div>
		</el-dialog>
		<!-- 文件夹上重写右键菜单 -->
		<ul v-show="rightClickVisible" :style="{ left: left + 'px', top: top + 'px' }" class="contextmenu">
			<li @click="editDir">
				<i class="el-icon-edit-outline"></i>
				编辑文件夹
			</li>
			<li @click="deleteDir">
				<i class="el-icon-delete"></i>
				删除文件夹
			</li>
			<li @click="moveFileToDir()">
				<i class="el-icon-refresh"></i>
				移动到此目录
			</li>
		</ul>
	</div>
</template>
<script>
import { mapState, mapMutations } from 'vuex';
export default {
	name: 'upfileManage',
	data() {
		return {
			fileList: [],
			path: '',
			dialogVisible: false,
			viewType: 1,
			uploadAccept: '',
			formDate: '',
			files: [],
			i: 0,
			crtDirShow: false,
			ctrDir: {
				filedir_id: '',
				filedir_name: ''
			},
			rightClickVisible: false,
			top: 0,
			left: 0,
			rightClickItem: '',
			file_checked: [],
			dirid:0//子文件夹id
		};
	},
	mounted() {
		this.getFileConfig();
	},
	activated() {
		// if(this.$store.state.auth.pageRefresh){
		// 	this.getUpFile();
		// 	this.setPageRefresh(false);
		// }
	},
	watch: {
		rightClickVisible(value) {
			console.log('aaaaaaa',value);
			if (value) {
				document.body.addEventListener('click', this.closeMenu);
			} else {
				document.body.removeEventListener('click', this.closeMenu);
			}
		}
	},
	methods: {
		fileIsChecked(file){
			return this.file_checked.includes(file.file_id);
		},
		...mapMutations({
			setPageRefresh: 'auth/setPageRefresh'
		}),
		// 文件夹右键菜单操作
		openMenu(e, item) {
			this.rightClickItem = item;
			let x = e.clientX;
			let y = e.clientY;
			this.top = y;
			this.left = x;
			this.rightClickVisible = true;
		},
		closeMenu() {
			this.rightClickVisible = false;
		},
		crtNewDir(){
			this.ctrDir = {
				filedir_id: '',
				filedir_name: ''
			};
			this.crtDirShow = true;
		},
		editDir() {
			this.ctrDir = this.rightClickItem;
			this.crtDirShow = true;
		},
		moveFileToDir(isroot){
			this.$axios({
				url: this.HOST + '/admin.files/moveFileToDir',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					fileIds:this.file_checked,
					file_path:isroot?'':this.path+'/'+this.rightClickItem.filedir_name,
					filedir_id:isroot?0:this.rightClickItem.filedir_id
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.file_checked = [];
						this.getUpFile();
					}
				})
				.catch(err => {});
		},
		deleteDir(){
			this.$confirm('此操作会删除当前选中目录及目录下所有文件，一旦删除无法恢复！是否删除？')
			.then(_=>{
				this.$axios({
					url: this.HOST + '/admin.files/deleteUpFileDir',
					method: 'post',
					data: {
						adminid: JSON.parse(this.$store.state.user.userInfo).id,
						token: JSON.parse(this.$store.state.user.userInfo).token,
						dirid:this.rightClickItem.filedir_id,
					}
				})
					.then(res => {
						console.log(res.data);
						if (res.data.status == 0) {
							if (res.data.admin_err == 'admininfo_error') {
								this.$message.error(res.data.msg);
								this.exit().then(res => {
									console.log(res);
									if (res.actionStatus == 1) {
										this.$router.push('/login');
									}
								});
							}
						} else {
							this.file_checked = [];
							this.getUpFile();
						}
					})
					.catch(err => {});
			})
			.catch(cancel=>{
				
			})
		},
		deleteFile(){
			if(!this.file_checked.length){
				this.$message.error('尚未选中任何文件');
				return false;
			}
			this.$confirm('此操作会删除当前选中的所有文件，文件一旦删除无法恢复！是否删除？')
			.then(_=>{
				this.$axios({
					url: this.HOST + '/admin.files/deleteUpFile',
					method: 'post',
					data: {
						adminid: JSON.parse(this.$store.state.user.userInfo).id,
						token: JSON.parse(this.$store.state.user.userInfo).token,
						fileIds:this.file_checked,
					}
				})
					.then(res => {
						console.log(res.data);
						if (res.data.status == 0) {
							if (res.data.admin_err == 'admininfo_error') {
								this.$message.error(res.data.msg);
								this.exit().then(res => {
									console.log(res);
									if (res.actionStatus == 1) {
										this.$router.push('/login');
									}
								});
							}
						} else {
							this.file_checked = [];
							this.getUpFile();
						}
					})
					.catch(err => {});
			})
			.catch(cancel=>{
				
			})
		},
		scanFile(){
			this.$confirm('此操作会扫描当前项目中所有文件并移除失效及读取失败的文件，请谨慎！是否继续操作？')
			.then(_=>{
				this.$axios({
					url: this.HOST + '/admin.files/scanUpFile',
					method: 'post',
					data: {
						adminid: JSON.parse(this.$store.state.user.userInfo).id,
						token: JSON.parse(this.$store.state.user.userInfo).token
					}
				})
					.then(res => {
						console.log(res.data);
						if (res.data.status == 0) {
							this.$message.error(res.data.msg);
							if (res.data.admin_err == 'admininfo_error') {
								this.exit().then(res => {
									console.log(res);
									if (res.actionStatus == 1) {
										this.$router.push('/login');
									}
								});
							}
						} else {
							this.$message.success(res.data.msg);
							this.getUpFile();
						}
					})
					.catch(err => {});
			})
			.catch(cancel=>{
				
			})
		},
		// 获取上传文件配置
		getFileConfig() {
			this.$axios({
				url: this.HOST + '/admin.files/upFileConfig',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						// this.path = res.data.file_dir;
						let uploadtypes = res.data.file_type.split(',');
						uploadtypes = uploadtypes.map(item => {
							if (item.indexOf('.') == '-1') {
								console.log('has not .', item);
								return (item = '.' + item);
							}
						});
						this.uploadAccept = uploadtypes.join(',');
						console.log(this.uploadAccept);
						this.getUpFile();
					}
				})
				.catch(err => {});
		},
		// 创建文件夹
		crtDirConfirm() {
			this.$axios({
				url: this.HOST + '/admin.files/createDir',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					ctrDir: this.ctrDir,
					path: this.path,
					filedir_lastid:this.dirid
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.ctrDir = {
							filedir_id: '',
							filedir_name: ''
						};
						this.crtDirShow = false;
						this.getUpFile();
					}
				})
				.catch(err => {});
		},
		// 获取当前文件夹下文件及文件夹列表
		getUpFile(path = '') {
			this.$axios({
				url: this.HOST + '/admin.files/searchUpFile',
				method: 'post',
				data: {
					adminid: JSON.parse(this.$store.state.user.userInfo).id,
					token: JSON.parse(this.$store.state.user.userInfo).token,
					path: path ? path : this.path,
					dirid:this.dirid
				}
			})
				.then(res => {
					console.log(res.data);
					if (res.data.status == 0) {
						if (res.data.admin_err == 'admininfo_error') {
							this.$message.error(res.data.msg);
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else {
						this.path = path ? path : this.path;
						console.log(this.path);
						this.fileList = res.data.list;
						this.dirid = res.data.dirid;
					}
				})
				.catch(err => {});
		},
		toUpDir() {
			let patharr = this.path.split('/');
			patharr.pop();
			this.path = patharr.join('/');
			console.log(this.path);
			this.getUpFile();
		},
		fileRowClick(row, column, event) {
			if (row.filedir_isdir) {
				let path = this.path ? this.path + '/' + row.filedir_name : row.filedir_name;
				console.log(path);
				this.dirid = row.filedir_id;
				this.getUpFile(path);
			} else {
				let file_id = row.file_id;
				let index = this.file_checked.indexOf(file_id);
				console.log(index);
				if (index === -1) {
					this.file_checked.push(file_id);
				} else {
					this.file_checked.splice(index, 1);
				}
				console.log(this.file_checked);
			}
		},
		canCheck(row, index) {
			if (row.filedir_isdir) {
				return false;
			} else {
				return true;
			}
		},
		openFile(scope) {
			let path = this.path + '/' + scope.filename;
			this.$router.push({ path: '/templateManage/fileEdit', query: { filepath: path } });
		},
		copyFile(scope) {
			// let path = this.path + '/' + scope.filename;
			this.$router.push({ path: '/templateManage/fileCopy', query: { filepath: this.path, filename: scope.filename } });
		},
		// 重写文件合并上传函数
		uploadFile(file) {
			this.formDate.append('file' + this.i, file.file);
			this.i++;
		},
		subPicForm() {
			this.formDate = new FormData();
			this.$refs.fileupload.submit();
			let userinfo = JSON.parse(this.$store.state.user.userInfo);
			this.formDate.append('adminid', userinfo.id);
			this.formDate.append('token', userinfo.token);
			this.formDate.append('path', this.path);
			let config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			};
			this.$axios
				.post(this.HOST + '/admin.files/uploadMultiFile', this.formDate, config)
				.then(res => {
					console.log(res);
					if (res.data.status == 0) {
						this.$message.error(res.data.msg);
						if (res.data.admin_err == 'admininfo_error') {
							this.exit().then(res => {
								console.log(res);
								if (res.actionStatus == 1) {
									this.$router.push('/login');
								}
							});
						}
					} else if (res.data.status == 1) {
						this.$message.success(res.data.msg);
						this.getUpFile();
						this.dialogVisible = false;
						this.$refs.fileupload.clearFiles();
					}
				})
				.catch(res => {
					console.log(res);
				});
		},
		// 重写文件合并上传函数结束
		//优化词选中列表变动
		selectChange(selection) {
			let arr = [];
			for (let i in selection) {
				arr.push(selection[i].file_id);
			}
			this.file_checked = arr;
			console.log(this.file_checked);
		},
		// 文件上传回调
		fileUploaded(file, name) {
			console.log(file, name);
			if (file.length) {
				this.$message.success('文件上传成功');
				this.$refs.fileupload.clearFiles();
				this.dialogVisible = false;
				this.getUpFile();
			} else {
				this.$message.error('文件格式不支持，请重试');
				this.$refs.fileupload.clearFiles();
			}
		},
		// 图片移除
		fileRemove(file, name) {
			console.log(file, name);
		},
		// 文件删除
		tempFileDelete(scope) {
			console.log(scope);
			this.$confirm('是否要删除模板文件？此操作一经删除不可恢复！')
				.then(() => {
					this.$axios({
						url: this.HOST + '/admin.files/deleteFile',
						method: 'post',
						data: {
							adminid: JSON.parse(this.$store.state.user.userInfo).id,
							token: JSON.parse(this.$store.state.user.userInfo).token,
							filepath: this.path,
							filename: scope.filename
						}
					})
						.then(res => {
							console.log(res.data);
							if (res.data.status == 0) {
								this.$message.error(res.data.msg);
								if (res.data.admin_err == 'admininfo_error') {
									this.exit().then(res => {
										console.log(res);
										if (res.actionStatus == 1) {
											this.$router.push('/login');
										}
									});
								}
							} else {
								this.$message.success(res.data.msg);
								this.getUpFile();
							}
						})
						.catch(err => {});
				})
				.catch(() => {});
		}
	}
};
</script>
<style lang="scss">
.el-main {
	padding: 0;
	.navpage {
		min-height: calc(100vh - 161px);
		.aside-primary {
			width: 240px;
			height: 100%;
			background-color: #ecf5ff;
			// height: 100%;
			padding: 20px;
			.el-divider__text {
				background-color: #ecf5ff;
				padding: 0 2px;
				font-size: 13px;
			}
			.el-menu-parent {
				background-color: transparent;
				.el-submenu {
					margin-bottom: 10px;
					background-color: #fff;
				}
				.el-menu-item {
					height: 45px;
					line-height: 45px;
					margin-bottom: 10px;
					background-color: #fff;
					min-width: 180px;
				}
			}
		}
		.width240 {
			width: 240px !important;
			transition: 0.8s;
		}
		.width0 {
			width: 0 !important;
		}
		.color-green {
			color: green;
		}
		.color-red {
			color: #ff2f4b;
		}
		.el-dropdown {
			margin: 0 10px;
		}
		.el-button + .el-button-group {
			margin-left: 10px;
			margin-right: 10px;
		}
		.view_preview {
			display: grid;
			grid-template-columns: repeat(auto-fill, 108px);
			grid-gap: 15px;
			.view-item {
				position: relative;
				width: 108px;
				height: 108px;
				overflow: hidden;
				text-align: center;
				p {
					position: absolute;
					width: 100%;
					height: 28px;
					line-height: 28px;
					background: rgba($color: #207d26, $alpha: 0.5);
					color: #ffffff;
					bottom: 0;
				}
				img {
					width: 108px;
					height: 108px;
					border-radius: 5px;
				}
				i.file_type {
					width: 70px;
					height: 70px;
					font-size: 70px;
					color: #efba4f;
					font-weight: 500;
				}
			}
		}
	}
	// 文件夹右键菜单样式
	.contextmenu {
		margin: 0;
		background: #fff;
		z-index: 3000;
		position: fixed;
		list-style-type: none;
		padding: 5px 0;
		border-radius: 4px;
		font-size: 12px;
		font-weight: 400;
		color: #333;
		box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
	}

	.contextmenu li {
		margin: 0;
		padding: 7px 16px;
		cursor: pointer;
	}

	.contextmenu li:hover {
		background-color: rgb(3, 125, 243);
		color: white;
	}
	.icon-xuanzhong{
		position: absolute;
		bottom: 0;
		right: 0;
		font-size: 45px;
	}
}
</style>
